import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'


Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        // https://coolors.co/
        themes: {
            light: {
                // Unsued (Silver): #757780
                // Unsued (Green): #B8EBD0
                // These come straight from Coolors.
                // primary: '#F1A59E',
                // primary: '#F4DFE1',
                primary: {
                    darken3: '#ED6A5A',
                    darken2: '#EE7E71',
                    darken1: '#EF9187',
                    base: '#F1A59E',
                    lighten1: '#F2B8B4',
                    lighten2: '#F3CCCB',
                    lighten3: '#F4DFE1'
                },
                secondary: '#9DCEF1',

                error: '#E34739',
                success: '#9DF1A4',
                warning: '#EAF19D',

                // These were not modified.
                accent: '#7C1B12',
                info: '#EA766B'
            }
        }
    },
    icons: {
        iconfont: 'fa',
        values: {
            menu: 'fa-bars',
            home: 'fa-home',
            settings: 'fa-user-cog',
            about: 'fa-question-circle',
            plus: 'fa-plus',
            heart: 'fa-heart'
        }
    }
})
